import { StaticTokens } from './API';

export const getUserToken = () => {
  const rawUser = localStorage.getItem('user');
  if (!rawUser) {
    return null;
  }
  try {
    return JSON.parse(rawUser)?.token ?? null;
  } catch {
    return null;
  }
};

export function commonHeaders() {
  const token = getUserToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json'
  };

  if (token) {
    headers['X-API-TOKEN'] = token;
  }

  return { headers };
}

/** Токен табло: из query-параметра URL (?token=...) или статический fallback */
export function getMonitorToken(): string | null {
  const fromUrl = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('token')
    : null;
  return fromUrl || StaticTokens.monitorToken || null;
}

/** Код филиала из query-параметра URL (?branch=...) для однозначного определения очереди */
export function getMonitorBranchCode(): string | null {
  if (typeof window === 'undefined') return null;
  const code = new URLSearchParams(window.location.search).get('branch');
  return code?.trim() || null;
}

/** Наименование очереди из query-параметра URL (?queue=...) для окна оператора */
export function getOperatorQueueName(): string | null {
  if (typeof window === 'undefined') return null;
  const name = new URLSearchParams(window.location.search).get('queue');
  return name?.trim() || null;
}

export function queueScreenHeaders() {
  const token = getMonitorToken();
  const branch = getMonitorBranchCode();
  const params: Record<string, string> = {};
  // Токен и branch только в query: бэкенд читает их из params/Referer.
  // Не шлём X-API-TOKEN — иначе браузер делает CORS-preflight, а старые
  // WebView/kiosk часто падают на Access-Control-Allow-Headers.
  if (token) params.token = token;
  if (branch) params.branch = branch;
  return {
    params: Object.keys(params).length > 0 ? params : undefined
  };
}

export function multipartHeaders() {
  const token = getUserToken();
  const headers: Record<string, string> = {
    'Content-Type': 'multipart/form-data'
  };

  if (token) {
    headers['X-API-TOKEN'] = token;
  }

  return { headers };
}
